import { ZPlayNetworkService } from "commons";

import AuthenticationService from "./authentication-service";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export class TimelineService {

	public static getTimelineContent = (callback: any, errCallback: any) => {

		let apiUrl = (!AuthenticationService.getLocalCurrentUser() && process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "true") ?
			`${API_BASE_URL}/api/public/contents/timeline` : `${API_BASE_URL}/api/contents/timeline`;

		ZPlayNetworkService.get(apiUrl, callback, errCallback);
	};
}